import { padStart } from "lodash";

export const convertMinsSinceMidnightTo24HourTime = (
  mins: number,
  opts: { format: boolean } = { format: false },
): string => {
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  return `${padStart(hours.toString(), 2, "0")}${
    opts.format ? ":" : ""
  }${padStart(minutes.toString(), 2, "0")}`;
};

export const convertMinsfrom24HourTimeToSinceMidnight = (
  timeString: string,
): number | null => {
  if (!timeString || timeString === "") {
    return null;
  }
  const splitTime = timeString.split(":");
  const transformedHours = Math.floor(parseFloat(splitTime[0]) * 60);
  const transformedMinutes =
    Math.floor((parseFloat(splitTime[1]) / 60) * 60) || 0;
  return transformedHours + transformedMinutes;
};
